import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { trans } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-metrics';
import { Autocompleter } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Autocompleter/Autocompleter.css';

const MIN_LENGTH_AUTOCOMPLETER = 1;

const trackNoResult = value => {
  Metrics.ga.sendEvent('Alerts', 'Select City -- Autocompleter', value);
};

class CityAutocompleter extends Component {
  static propTypes = {
    cities: PropTypes.shape({
      [PropTypes.string]: PropTypes.shape({
        name: PropTypes.string,
        currencyIsoCode: PropTypes.string
      })
    }).isRequired,
    cityName: PropTypes.string,
    cityId: PropTypes.string,
    cityNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    onSelectedElement: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    hasError: PropTypes.bool
  };

  static defaultProps = {
    cityName: '',
    cityId: '',
    hasError: false
  };

  shouldComponentUpdate = nextProps =>
    nextProps.cityId !== this.props.cityId ||
    nextProps.hasError !== this.props.hasError;

  selectCity = cityName => {
    const cityId = Object.keys(this.props.cities).find(
      city => this.props.cities[city].name === cityName
    );
    this.props.onSelectedElement(
      {
        cityId,
        currencyIsoCode: this.props.cities[cityId].currencyIsoCode
      },
      cityName
    );
  };

  handleNoResults = value => {
    trackNoResult(value);
  };

  render() {
    const { hasError } = this.props;
    const autocompleterClassName = classNames(
      'add-edit-form__autocompleter-wrapper',
      {
        'add-edit-form__autocompleter-wrapper--has-error': hasError
      }
    );

    return (
      <Fragment>
        <div className="add-edit-form__grid-label">
          {trans('alerts.modal.city')}
        </div>
        <div className={autocompleterClassName}>
          <Autocompleter
            initialValue={this.props.cityName}
            list={this.props.cityNames}
            minLength={MIN_LENGTH_AUTOCOMPLETER}
            placeholder={trans('landingpage.city_selector.select_city')}
            onSelectedElement={this.selectCity}
            onNoResults={this.handleNoResults}
            onChange={this.props.onChange}
            hasError={hasError}
          />
          {hasError && (
            <div className="add-edit-form__error-message">
              {trans('alerts.modal.city.error')}
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default CityAutocompleter;
